module.exports = __webpack_public_path__ + "static/media/logo.29755824.png";